import { Modal } from "react-blueprint-library";
import NavigationButtons from "../../SharedComponents/NavigationButtons";

export default function MMLISContributionDeleteModal(props) {
  return (
    <>
      <div>
        <div id="backModal"></div>

        <div>
          <Modal
            id="logoutModal"
            show={props.isOpen}
            className="modal-md"
            title=""
          >
            <div>
              <div className="modal-body" id="top_delete_element">
                <div className="container">
                  <div className="modal-header">
                    <h2>{props.message}</h2>
                    <div style={{ marginTop: "12px" }}>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close modal dialog"
                        onClick={props.closeClick}
                      />
                    </div>
                  </div>
                  <NavigationButtons
                    onBack={props.closeClick}
                    onNext={props.deleteClick}
                    isLoading={props.show_spinner}
                    isDisabled={props.show_spinner}
                    backBtnText="No, Never Mind"
                    nextBtnText="Yes"
                    nxtbtnid={"yes_btn"}
                    bckbtnid={"no_btn"}
                  />
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    </>
  );
}
